var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30316 4.25286C8.17351 1.38251 12.8273 1.38251 15.6976 4.25286C18.568 7.12322 18.568 11.777 15.6976 14.6473L10.5004 19.8446L5.30316 14.6473C2.4328 11.777 2.4328 7.12322 5.30316 4.25286ZM10.5004 11.5501C11.6602 11.5501 12.6004 10.6099 12.6004 9.4501C12.6004 8.2903 11.6602 7.3501 10.5004 7.3501C9.34059 7.3501 8.40039 8.2903 8.40039 9.4501C8.40039 10.6099 9.34059 11.5501 10.5004 11.5501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.eeffe4e8561128107c3645670cbf6cd5.svg";
export { ForwardRef as ReactComponent };